export default () => ({
    webSidebarIsOpen: true,
    get sidebarType() {
        return window.innerWidth < 1024 ? 'mobile' : 'web';
    },
    setSidebarIsOpen() {
        const isOpen = localStorage.getItem('sidebarOpen') === 'true'
        const isMobile = this.sidebarType === 'mobile';

        this.webSidebarIsOpen = isOpen && !isMobile;
    },
    init() {
        this.setSidebarIsOpen();
    }
});
